// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"40":"6f208f79","261":"80137e16","522":"d531f807"}[chunkId] + ".css";
};